module.exports = {"654324100":"阿克齐镇","654324101":"萨尔布拉克镇","654324102":"齐巴尔镇","654324103":"库勒拜镇","654324200":"萨尔塔木乡","654324201":"加依勒玛乡","654324204":"铁热克提乡","654324500":"兵团一八五团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654324.json
// module id = 3147
// module chunks = 0